// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PencilSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M7.11 3.991A1.5 1.5 0 1 0 4.89 6.01l5.705 6.275-6.362 6.362a2.484 2.484 0 0 0-.733 1.768V26A2.5 2.5 0 0 0 6 28.5h5.586a2.482 2.482 0 0 0 1.768-.733l5.928-5.927 5.61 6.169a1.5 1.5 0 1 0 2.22-2.018l-20.002-22Zm6.819 11.96L8.5 21.375 7.125 20l5.5-5.494 1.304 1.445ZM6.5 23.625 8.375 25.5H6.5v-1.875Zm5.5 1.25L10.625 23.5l5.328-5.328 1.313 1.445L12 24.875ZM28.769 8.818l-5.586-5.585a2.5 2.5 0 0 0-3.535 0l-4.5 4.5a1.5 1.5 0 0 0 1.818 2.352l1.419 1.415a1.5 1.5 0 0 0 2.115 2.116L21.875 15l-.067.066a1.504 1.504 0 0 0 2.125 2.125l4.833-4.833a2.503 2.503 0 0 0 .003-3.54ZM24 12.875 19.125 8l2.293-2.293 4.875 4.875L24 12.875Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
